import React, { Component } from 'react';

class About extends Component {
  render() {
    return <div class="container" align="left">
    <h1>About</h1>
    <hr/>
    <p>
    Model Zoo curates and provides a platform for deep learning researchers to easily find pre-trained models for a variety of platforms and uses. We regularly update the site, and provide filtering functionality for users to find models that they need, either for educational purposes, transfer learning, or other uses.
    </p>

    <p>Like us on <a href="https://www.facebook.com/Model-Zoo-209080699902427" target="_blank">Facebook</a> or follow us on <a href="https://twitter.com/model_zoo" target="_blank">Twitter</a>!</p>

    <p>Do you have a suggestion for Model Zoo, or any comments about the site? Drop us an email at info[at]modelzoo.co!</p>

    <p>Model Zoo was built with love in Singapore by <a href="http://kohjingyu.com" target="_blank">Jing Yu Koh</a>.</p>
    </div>;
  }
}

export default About



// WEBPACK FOOTER //
// ./src/About.jsx